<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <CollapseResource
          v-if="item.key === '2'"
          title="制度建设"
          :actionUrl="currTabObj.url"
          sortDictCode="research_sort"
          :isShowSort="item.key === '5'"
          :actionType="item.key"
        />
        <SchemeCard
          v-else
          ref="schemeCardRef"
          :key="item.key"
          :actionUrl="currTabObj.url"
          :cardType="item.cardType"
          :fileUploadKey="currTabObj.fileUploadKey"
          :keysFormArr="currTabObj.keysFormArr"
          :cateDictCode="currTabObj.dictCode"
          :acceptSuffix="currTabObj.acceptSuffix"
          @cardClick="schemeCardClick"
        />
      </a-tab-pane>
      <a-button
        v-show="activeKey !== '2'"
        type="primary"
        slot="tabBarExtraContent"
        @click="createLeague"
      >
        创建
      </a-button>
    </a-tabs>
  </div>
</template>
<script>
import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'
// import CreateCourseModal from '@/comUi/CreateCourseModal'
import SchemeDetails from '@/comUi/SchemeCard/components/SchemeDetails'
import CollapseResource from '@/comUi/CollapseResource'

export default {
  name: 'ConsultingRoom',
  components: {
    SchemeCard,
    SchemeDetails,
    CollapseResource,
  },
  data() {
    return {
      activeKey: '0',
      loading: false,
      tabList: [
        {
          tab: '硬件标准化',
          key: '0',
          url: 'resourceHardware',
          dictCode: 'hardware_sort',
          cardType: '1',
          fileUploadKey: 'file',
          keysFormArr: [],
        },
        {
          tab: '文化建设',
          key: '1',
          url: 'resourceCultural',
          dictCode: 'cultural_sort',
          acceptSuffix: '.zip',
          cardType: '2',
          fileUploadKey: 'file',
          keysFormArr: ['title', 'classify', 'cover', 'file'],
        },
        {
          tab: '制度建设',
          key: '2',
          url: 'resourceCource',
        },
      ],
      categoryList: [],
      fitGradeList: [],
      cardList: [],
      cardObj: {},
      queryParam: {
        pageNo: 1,
        pageSize: 12,
      },
      total: 0,
    }
  },
  computed: {
    currTabObj() {
      return this.tabList.find((item) => item.key === this.activeKey)
    },
  },
  created() {
    const backKey = this.$router.history.current.query?.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    },
    createLeague() {
      // this.$refs.createCourseModalRef.showModal()
      this.$refs.schemeCardRef[0].showCardModal()
    },
    schemeCardClick(data) {
      this.cardObj = data
    },
  },
}
</script>
